import React from "react";
import { Col } from "react-bootstrap";
import { useGetMenuBarData } from "./api/getMenuBarData";
import { Dropdown } from "../../../lib/Checkboxes";
import { PeriodicalDropdown } from "./parts/PeriodicalDropdown";

export const MenuDropdowns = () => {
  const formData = useGetMenuBarData();
  return (
    <>
      <Col md="3" xs="4" className="maxw-225 dropdown-col">
        <Dropdown name="regions" formData={formData} />
      </Col>

      <Col md="3" xs="4" className="maxw-340 dropdown-col">
        <PeriodicalDropdown formData={formData} />
      </Col>

      <Col md="3" xs="4" className="maxw-340 dropdown-col">
        <Dropdown name="txSubCategories" formData={formData} />
      </Col>
    </>
  );
};
